<sc-master-detail [selection]="[selectedOption]" [data]="selectDefinition.options"
    (selectionChanged)="onSelectionChanged($event);" (addEntry)="onAddEntry($event);"
    (deleteEntry)="onDeleteEntry($event);" [level]="2" class="template-lookup-editor">

    <sc-padding *ngIf="selectedOption">

        <sc-flex [vertical]="true" [fitHeight]="true" [stretchContent]="true">

            <div class="value-details no-field-space">
                <ng-container [formGroup]="optionDetailsFormGroup" *ngIf="selectDefinition != null">
                    <mat-form-field class="full-size-field" appearance="fill">
                        <mat-label>{{'identifier' |
                            translate:['tmc-yard.entity.document-template-select-definition.identifier',
                            translationService.language]}}</mat-label>
                        <input matInput name="identifier" formControlName="identifier" [required]="true"
                            [maxLength]="255">
                    </mat-form-field>
                </ng-container>
            </div>

            <sc-content-spacer [vertical]="true"></sc-content-spacer>

            <div class="field-value-title">abhängige Feldwerte</div>
            <sc-list-spacer [levelClass]="'level-2'"></sc-list-spacer>
            <div class="field-details" [formGroup]="attributeValueDetailsFormGroup">
                <ng-container *ngFor="let attributeValue of selectedOption?.attributeValues">
                    <div class="field-entry" (click)="selectAttribute(attributeValue)"
                        [ngClass]="{'selected': selectedAttribute === attributeValue}">
                        <sc-flex >
                            <div class="field-name">
                                <span *ngIf="selectedAttribute !== attributeValue">{{attributeValue.key}}</span>
                                <mat-form-field class="full-size-field" appearance="fill"
                                    *ngIf="selectedAttribute === attributeValue">
                                    <mat-label>{{'identifier' |
                                        translate:['tmc-yard.entity.document-template-select-definition.identifier',
                                        translationService.language]}}</mat-label>
                                    <input matInput name="key" formControlName="key" [required]="true"
                                        [maxLength]="255">
                                </mat-form-field>
                            </div>
                            <sc-content-spacer></sc-content-spacer>
                            <div class="field-value">
                                <span *ngIf="selectedAttribute !== attributeValue">{{attributeValue.value}}</span>
                                <mat-form-field class="full-size-field" appearance="fill"
                                    *ngIf="selectedAttribute === attributeValue">
                                    <mat-label>{{'identifier' |
                                        translate:['tmc-yard.entity.document-template-select-definition.identifier',
                                        translationService.language]}}</mat-label>
                                    <input matInput name="value" formControlName="value" [required]="true"
                                        [maxLength]="255">
                                </mat-form-field>
                            </div>
                            <sc-content-spacer [grow]="true" *ngIf="selectedAttribute === attributeValue">
                            </sc-content-spacer>
                            <div class="field-action" *ngIf="selectedAttribute === attributeValue"><i
                                    class="fa-light fa-trash" (click)="deleteAttribute(attributeValue)"></i></div>
                        </sc-flex>
                    </div>
                    <sc-list-spacer [levelClass]="'level-2'"></sc-list-spacer>
                </ng-container>
            </div>

            <sc-content-spacer [vertical]="true"></sc-content-spacer>

            <sc-flex [centered]="true">
                <button mat-stroked-button (click)="addAttribute()">
                    <mat-icon><sc-icon iconClass="fa-plus"></sc-icon></mat-icon>
                    add
                </button>
            </sc-flex>

        </sc-flex>

    </sc-padding>

</sc-master-detail>